var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gameItem3Dian5",staticStyle:{"display":"flex","flex-wrap":"wrap","width":"100%"}},_vm._l((_vm.itemListConter.list),function(item,index){return _c('gameItem',{key:index,attrs:{"item":{...item,type:'game'}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }